import { Component } from '@angular/core';
import { PRICE_TIERS, FLEET_PRICE_TIERS } from '../data/price-tier';
import { Router } from '@angular/router';
import { PriceTierService } from '../services/price-tier.service';
import { FuncsService } from '../services/funcs.service';

@Component({
  selector: 'app-tiers',
  templateUrl: './tiers.component.html',
  styleUrls: ['./tiers.component.css'],
  standalone: false
})

export class TiersComponent {
  public loading = "";
  priceTiers = PRICE_TIERS;
  canadaPriceTiers = PRICE_TIERS;
  fleetPriceTiers = FLEET_PRICE_TIERS;

  constructor(
    private priceTierService: PriceTierService,
    private router: Router,
    private funcs: FuncsService
  ) { }

  ngOnInit(): void {
    this.funcs.checkAdmin();
    this.loading = "Loading...";
    this.getPrices();
  }

  getPrices() {
    this.priceTierService.getPriceTiers().subscribe(tiers => {
      this.priceTiers = tiers;
      this.loading = "";
    });

    this.priceTierService.getCanadaPriceTiers().subscribe(tiers => {
      this.canadaPriceTiers = tiers;
      this.loading = "";
    });

    this.priceTierService.getFleetPriceTiers().subscribe(tiers => {
      this.fleetPriceTiers = tiers;
      this.loading = "";
    });
  }

  updateQty(idx: number, type: string) {
    this.loading = "Updating...";

    if (type == 'dealer') {
      this.priceTierService.updatePriceTier(this.priceTiers[idx]).subscribe(rsp => {
        this.loading = "";
      });
    }

    if (type == 'canada') {
      this.priceTierService.updatePriceTier(this.canadaPriceTiers[idx]).subscribe(rsp => {
        this.loading = "";
      });
    }

    if (type == 'fleet') {
      this.priceTierService.updatePriceTier(this.fleetPriceTiers[idx]).subscribe(rsp => {
        this.loading = "";
      });
    }
  }
}
